var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"btn",class:{'loading': _vm.loading},attrs:{"type":_vm.type,"value":_vm.value,"ariaType":_vm.ariaType,"disabled":_vm.currentlyDisabled}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }